<template>
 <div>
  <div class="generatedCode"></div>
  <div>
    <div 
    class="g-ytsubscribe" 
    data-channel="rixtrema" 
    data-layout="default" 
    data-count="default"
    >
    </div>
  </div>
  

 </div>
</template>
<script>
export default{
 name: 'Linkedin',
 mounted() {  
  this.LiPart_2();
},
 methods: {  
  LiPart_2(){
    let generatedCode = document.getElementsByClassName('generatedCode')
    for(let i=0; i<generatedCode.length; i++){
        generatedCode[i].innerHTML = '<script type="IN/FollowCompany" data-id="1334326" data-counter="bottom"><\/script>'
    }
     
  }
 },
 
}
</script>
<style lang="sass" scoped>
div
  display: flex
  margin: 5px
  align-items: center
</style>